/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: disaEntriesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Applications module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { buildApiUrl, getApiHeaders } from '../../config/api';

/**
 * Shared helpers for DISA Entries module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a DISA Entry in the form.
 * Pattern: /pbx/applications/disa/new?duplicate={id}
 */
export const getDisaEntryDuplicateUrl = (id: string | number): string =>
  `/pbx/applications/disa/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given DISA Entry id.
 */
export const navigateToDisaEntryDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getDisaEntryDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a DISA Entry by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteDisaEntryById = async (id: string | number): Promise<void> => {
  const response = await fetch(
    buildApiUrl(`/api/telephony/disa-entries/${id}`),
    {
      method: 'DELETE',
      headers: getApiHeaders(),
    },
  );

  if (!response.ok) {
    let message = 'Failed to delete DISA entry';
    try {
      const errorData = await response.json();
      if (errorData?.message) {
        message = errorData.message;
      }
    } catch {
      // Ignore JSON parse errors and use default message
    }
    throw new Error(message);
  }
};



